import type { TProjectDetail } from '@/apis/typings'

/**
 * 获取验证头部
 * @param {String} token - token
 * @returns {String}
 */
export function getProjectApp(): TProjectDetail | undefined {
  const storage = localStorage.getItem('root-storage')
    ? JSON.parse(localStorage.getItem('root-storage') as string)
    : ''

  return storage?.state?.currentProject
}
